import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'documenti';

const getDocumenti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_documenti" , data: params}, callback);

const apiEndpoint = {
  getDocumenti
}

export default apiEndpoint;